import React from "react"
import { Navigate } from "react-router-dom"
import { ROUTE_PATHS } from "utils/routes"
import { useAuth } from "hooks/useAuth"

export const AdminRoute = ({ children }) => {
    const { isAuthenticated, isAdmin, initializing } = useAuth();
    
    // Show loading while initializing
    if (initializing) {
        return <div>Loading...</div>;
    }
    
    if (!isAuthenticated) {
        return <Navigate to={ROUTE_PATHS.INICIOSESION} />
    }
    
    if (!isAdmin()) {
        // Redirect non-admin users to main landing page
        return <Navigate to="/" />
    }

    return children
}

export const UserRoute = ({ children }) => {
    const { isAuthenticated, isUser, initializing } = useAuth();
    
    // Show loading while initializing
    if (initializing) {
        return <div>Loading...</div>;
    }
    
    if (!isAuthenticated) {
        return <Navigate to={ROUTE_PATHS.INICIOSESION} />
    }
    
    if (!isUser()) {
        // Redirect non-user to appropriate page (admin to dashboard)
        return <Navigate to={ROUTE_PATHS.ADMINDASHBOARD} />
    }

    return children
}

export const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
    const { isAuthenticated, getUserRole, initializing } = useAuth();
    
    // Show loading while initializing
    if (initializing) {
        return <div>Loading...</div>;
    }
    
    if (!isAuthenticated) {
        return <Navigate to={ROUTE_PATHS.INICIOSESION} />
    }
    
    const userRole = getUserRole();
    if (!allowedRoles.includes(userRole)) {
        // Redirect based on role
        if (userRole === 'admin') {
            return <Navigate to={ROUTE_PATHS.ADMINDASHBOARD} />
        } else {
            return <Navigate to="/" />
        }
    }

    return children
}